export const routes = {
    profile: ({ codatCompanyId }: { codatCompanyId: string }) =>
        `https://app.codat.io/companies/${codatCompanyId}`,
    baseUrl: () => 'https://api.codat.io',
    inflowOutflowActivity: (args: { companyId: string }) => {
        return `/data/companies/${args.companyId}/assess/bankingMetrics/inflowOutflowActivity`
    },
}
